<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>

    <div v-if="campaignInfo !== null">
      <h2>Influencer Campaigns</h2>
      <div class="card">
        <div v-if="campaignInfo.campaigns.length < 1" style="padding: 10px">
          <h4>No campaigns</h4>
        </div>
        <div v-else style="padding: 25px">
          <el-table :data="campaignInfo.campaigns">
            <el-table-column
              label="Name"
              property="name"
              width="150px"
            ></el-table-column>
            <el-table-column
              label="Description"
              property="campaignDescription"
            ></el-table-column>
            <el-table-column label="Start Date" property="startDate">
              <template slot-scope="props">{{
                props.row.startDateString
              }}</template>
            </el-table-column>
            <el-table-column
              label="Influencers"
              property="influencerCount"
            ></el-table-column>
            <el-table-column label="Status" property="status"></el-table-column>
            <el-table-column label="Actions" width="300">
              <template slot-scope="props">
                <el-tooltip
                  content="Influencer List"
                  :open-delay="300"
                  placement="bottom"
                >
                  <p-button
                    class="button-space"
                    link
                    type="info"
                    round
                    icon
                    outline
                    @click="
                      $router.push('/influencer-campaign/list/' + props.row._id)
                    "
                  >
                    <i class="fas fa-list"></i
                  ></p-button>
                </el-tooltip>
                <el-tooltip
                  content="Analytics"
                  :open-delay="300"
                  placement="bottom"
                >
                  <p-button
                    class="button-space"
                    link
                    type="info"
                    round
                    icon
                    outline
                    @click="
                      $router.push(
                        '/influencer-campaign/analytics/' + props.row._id
                      )
                    "
                  >
                    <i class="far fa-chart-bar"></i
                  ></p-button>
                </el-tooltip>
                <el-tooltip
                  content="Campaign Details"
                  :open-delay="300"
                  placement="bottom"
                >
                  <p-button
                    class="button-space"
                    link
                    type="info"
                    round
                    icon
                    outline
                    @click="
                      $router.push(
                        '/influencer-campaign/details/' + props.row._id
                      )
                    "
                  >
                    <i class="fas fa-sliders-h"></i
                  ></p-button>
                </el-tooltip>
              </template>
            </el-table-column>
        
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import { Tooltip } from "element-ui";
import {
  influencerCampaignClientReadApi,
  userLoadApi,
} from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: false,
    campaigns: null,
    campaignInfo: null,
    isTeam: null,
    isClient: null,
  }),
  name: "InfluencerCampaignListClient",
  components: {
    [Tooltip.name]: Tooltip,
  },
  methods: {
    async loadCampaignList() {
      try {
        this.loadingOverlay = true;
        //console.log("CAMPAIGN ID:", this.$route.params.clientId);
        let influencerCampaignLoadUrl = `${influencerCampaignClientReadApi}/?usertoken=${this.auth}&client=${this.$route.params.clientId}`;
        let influencerCampaignList = await axios.get(influencerCampaignLoadUrl);
        //console.log("CAMPAIGN DATA: ", influencerCampaignList.data);
        if (influencerCampaignList.data.success === true) {
          this.campaignInfo = influencerCampaignList.data.result;
          this.campaigns = influencerCampaignList.data.result.campaigns;
          this.loadingOverlay = false;
        }
      } catch (err) {
        //console.log("CAMPAIGN LIST ERROR: ", err);
      }
    },
    async setProfileType() {
      try {
        if (this.profileStore.isTeam === true) {
          this.isTeam = true;
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (
        this.profileStore == false ||
        typeof this.profileStore == "undefined"
      ) {
        let profileLoadResponse = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileLoadResponse.data);
        if (profileLoadResponse.data.success === true) {
          this.profileData = profileLoadResponse.data.result;
          if (this.profileData.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (this.profileData.profileTypes.length > 0) {
              if (this.profileData.profileTypes.indexOf("influencer") !== -1) {
                this.isInfluencer = true;
              }
              if (this.profileData.profileTypes.indexOf("client") !== -1) {
                this.isClient = true;
              }
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        }
      }
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadCampaignList();
    this.setProfileType();
  },
};
</script>

<style scoped>
</style>